export const colors = {
  primary: 'bg-[#265073]',
  // primary: 'bg-[#27374D]',
  primaryText: 'text-[#526D82]',
  primaryBorder: 'border-[#526D82]',
  primaryButton: 'bg-[#27374D]',
  primaryPure: '#2B4865',
  primayIcon: 'text-[#176ba6]',
  tableText: 'text-[13px] text-[#505252] py-2',
};

export const snackBarColors = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export const markedDmcaCountLables = {
  markedDMCA: 'Marked for DMCA',
  markedRevisit: 'Marked for Revisit',
  ignored: 'Ignored',
};

export const markedDmcaPreferenceAction = {
  markedDMCA: 'Mark DMCA',
  markedRevisit: 'Revisit',
  ignored: 'Ignore',
};

export const apiUrl = process.env.REACT_APP_API_BASEURL;
